/**
 * Route for `igaming-ftd-event`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingFtdEventPage } from "../features/igaming-ftd-event/IgamingFtdEventPage";

export const igamingFtdEventRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-ftd-event",
	component: IgamingFtdEventPage,
});

export default igamingFtdEventRoute;
